export enum PlanogramTypes {
    All = -1,
    Planogram = 0,
    Store_Design = 1,
    Third_Party_Planogram = 2,
    Future_Planogram = 3,
}
